import ButtonIcon from "@visa/vds/button-icon";
import ButtonText from "@visa/vds/button-text";
import Chip from "@visa/vds/chip";
import ChipText from "@visa/vds/chip-text";
import FormControl from "@visa/vds/form-control";
import Icon from "@visa/vds/icon";
import Row from "@visa/vds/row";
import Select from "@visa/vds/select";
import React, { useState } from "react";
import MCSSpace from "../../../../components/MCSSpace";

const PostFormTagSection = (props) => {
  const [tagIdToAdd, setTagIdToAdd] = useState("");

  const handleClickAddTag = () => {
    props.handleClickAddTag(tagIdToAdd);
    setTagIdToAdd("");
  };
  return (
    <>
      <FormControl position="left" space="thirty">
        <Select
          value={tagIdToAdd}
          label="Tags"
          onChange={(e) => {
            setTagIdToAdd(e.target.value);
          }}
        >
          <option value="" disabled>
            - Select Tag -
          </option>
          {props.tagList &&
            props.tagList.map((item, k) => (
              <option key={k} value={"" + item.id}>
                {item.name}
              </option>
            ))}
        </Select>
      </FormControl>
      <FormControl position="left" space="thirty">
        <ButtonText
          style={{ marginTop: "29px" }}
          colorScheme="secondary"
          onClick={handleClickAddTag}
        >
          Add Tag
        </ButtonText>
      </FormControl>
      <MCSSpace></MCSSpace>
      <Row>
        {props.libraryPostLibraryTags &&
          props.libraryPostLibraryTags.map((item, k) => (
            <Chip key={k}>
              <ChipText>{item.libraryTag.name}</ChipText>
              <ButtonIcon
                dataid={item.libraryTag.name}
                ariaLabel="clear"
                iconType="light-tiny"
                onClick={props.handleClickRemoveTag}
                onFocus={(e) => e.target.blur()}
              >
                <Icon name="close" resolution="tiny" />
              </ButtonIcon>
            </Chip>
          ))}
      </Row>
    </>
  );
};

export default PostFormTagSection;
